import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFrontendAuth } from './session.js';

export function ForbiddenPage({
  title = 'Access Denied',
  message = 'You do not have permission to access this part of the workspace.',
}: {
  readonly title?: string;
  readonly message?: string;
}) {
  const navigate = useNavigate();

  return (
    <main className="content">
      <section className="panel">
        <h1>{title}</h1>
        <p>{message}</p>
        <button type="button" onClick={() => void navigate(-1)}>Go Back</button>
      </section>
    </main>
  );
}

export function OidcCallbackPage({
  fallbackPath = '/',
}: {
  readonly fallbackPath?: string;
}) {
  const auth = useFrontendAuth();
  const navigate = useNavigate();
  const callbackStarted = useRef(false);

  useEffect(() => {
    if (callbackStarted.current) return;
    callbackStarted.current = true;

    async function handle() {
      try {
        const returnTo = await auth.handleCallback?.();
        void navigate(returnTo ?? fallbackPath, { replace: true });
      } catch {
        void navigate(fallbackPath, { replace: true });
      }
    }

    void handle();
  }, [auth, fallbackPath, navigate]);

  return (
    <main className="content">
      <section className="panel">
        <h1>Completing sign-in</h1>
        <p>Please wait while the workspace restores your session.</p>
      </section>
    </main>
  );
}
